import PlaceholderImage from '@assets/images/ImgFinal_Suitability01.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './BrandSuitabilityOne.style';
import { useTranslation } from 'react-i18next';

const BrandSuitabilityOne = () => {
  const { t } = useTranslation('brandSuitability');

  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('brandSuitabilityOne.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <div className="text-content">
            <p>{t('brandSuitabilityOne.paragraphOne')}</p>
          </div>
        </TextBox1>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
        <TextBox2>
          <p>{t('brandSuitabilityOne.paragraphTwo')}</p>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSuitabilityOne;
